







































































































import { CameraImage } from "@/store/modules/CameraImage/interface";
import Utils from "@/utils/utils";
import Vue from "vue";
// For the next person who is trying to figure out why this is here, i'm sorry.

interface CssStyle {
  color?: string;
  backgroundColor?: string;
}

export default Vue.extend({
  name: "DeviceCardBoxPycam",
  props: {
    last_image: {
      type: Object,
      default: () => null
    },
    card_class: {
      type: String,
      default: ""
    },
    text_class: {
      type: String,
      default: ""
    }
  },
  components: {},
  data() {
    return {};
  },
  methods: {
    formattedDate(date: string | Date): string {
      return Utils.transformDateToYMDHMS(date);
    }
  },
  computed: {
    remplissageColor(): CssStyle {
      const actual_remplissage = (this.last_image as CameraImage)?.pycam_df_p as number;
      switch (true) {
        case actual_remplissage >= 80 && actual_remplissage < 90:
          return {
            color: "var(--alyce-orange)"
          };
        case actual_remplissage >= 90:
          return {
            color: "var(--button-no-color)"
          };
        default:
          return {
            color: "var(--button-yes-color)"
          };
      }
    }
  },
  watch: {}
});
